<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }} {{ suffixLabel }}</label>
    <TheMask v-if="type == 'mask'" :id="id" ref="input" v-bind="$attrs" class="form-input  h-10" :class="{ error: error }" :type="type" :value="value" @input="$emit('input', $event)" />
    <DatePicker v-else-if="type == 'datetime'" :id="id" ref="input" :lang="lang" format="DD/MM/YYYY" v-bind="$attrs" class="h-10" :class="{ error: error }" :type="type" :value="value" @input="$emit('input', $event)" />
    <DatePicker v-else-if="type == 'date'" :id="id" ref="input" value-type="YYYY-MM-DD" :lang="lang" format="DD/MM/YYYY" v-bind="$attrs" class="h-10" :class="{ error: error }" :type="type" :value="value" @input="$emit('input', $event)" />
    <input v-else :id="id" ref="input" v-bind="$attrs" class="form-input  h-10" :class="{ error: error }" :type="type" :value="value" @input="$emit('input', $event.target.value)" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import pt from 'vue2-datepicker/locale/pt-br'
export default {
  components: {TheMask, DatePicker},
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: null,
    label: String,
    error: String,
    suffixLabel: {
      type: String,
      default() {
        return ':'
      },
    },
  },
  data: function() {
    return ({
      lang: pt,
    })
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>

<style>
 .mx-datepicker{
     width: 100% !important;

 }

 .mx-input {
     height: 40px !important;
 }

 .mx-input:disabled, .mx-input.disabled {
     background: #f8fafc;
 }

</style>
